// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"6a518457","289":"4456554c"}[chunkId] + ".chunk.css";
};